"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@samknows/utils");
const Emitter_1 = require("./Emitter");
var WebSocketError;
(function (WebSocketError) {
    WebSocketError["CLOSED"] = "CLOSED";
    WebSocketError["CONNECTION_FAILED"] = "CONNECTION_FAILED";
    WebSocketError["ERROR"] = "ERROR";
})(WebSocketError || (WebSocketError = {}));
class WsTriggerTesting {
    constructor(config) {
        this.unitId = config.unitId;
        this.socketUrl = `${config.url}?session_id=${utils_1.Tracking.context.sessionId}`;
        if (config.accessToken) {
            this.socketUrl = `${this.socketUrl}&auth=${config.accessToken}`;
        }
    }
    connect() {
        return new Promise((resolve, reject) => {
            this.socket = new WebSocket(this.socketUrl);
            this.socket.onmessage = (event) => {
                const message = JSON.parse(event.data);
                const isTestNotRequestedFromUs = message.session_id !== utils_1.Tracking.context.sessionId;
                if (isTestNotRequestedFromUs) {
                    return;
                }
                const messageType = message.type;
                if (!['status', 'test'].includes(message.type)) {
                    return;
                }
                Emitter_1.internalEmitter.emit(`ws:${messageType}`, Object.assign({}, message));
            };
            this.socket.onopen = () => {
                this.sendMessage('status');
                resolve();
            };
            this.socket.onclose = () => {
                this.socket = undefined;
            };
            this.socket.onerror = () => {
                if (this.socket && typeof this.socket !== 'undefined') {
                    this.socket.close();
                    this.socket = undefined;
                }
                reject(new Error(WebSocketError.ERROR));
            };
        });
    }
    isAlive() {
        var _a;
        return ((_a = this.socket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN;
    }
    sendMessage(type, data) {
        if (!this.socket || typeof this.socket === 'undefined') {
            Emitter_1.emitter.emit('error', WebSocketError.CONNECTION_FAILED);
            return;
        }
        const dataWithUnitId = Object.assign({ unit_id: this.unitId }, data);
        const message = {
            type,
            data: dataWithUnitId
            // request_id is optional
        };
        this.socket.send(JSON.stringify(message));
    }
    disconnect() {
        if (!this.socket) {
            return;
        }
        this.socket.close();
        this.socket = undefined;
    }
}
exports.default = WsTriggerTesting;
//# sourceMappingURL=WsTriggerTesting.js.map